import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { withStyles } from "@material-ui/styles";
import { get, isEmpty, map, filter } from "lodash";
import moment from "moment-timezone";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";
import CustomSelect from "../../Common/CustomSelect";
import RecurrenceWeekly from "./RecurrenceWeekly";
import RecurrenceMonthly from "./RecurrenceMonthly";
import colors from "../../../assets/style/colors";
import RecurrenceDaily from "./RecurrenceDaily";

const styles = {
  dialogPaper: {
    padding: "12px",
    minWidth: "430px",
    maxWidth: "430px",
  },
  closeIconItem: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  link: {
    cursor: "pointer",
    color: colors.primary,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  daySquare: {
    width: "24px",
    height: "24px",
    border: `1px solid ${colors.darkGrey}`,
    borderRadius: "1px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  daySquareActive: {
    backgroundColor: colors.black,
    color: colors.white,
  },
  label: {
    width: "60px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
  },
  row: {
    marginBottom: "24px",
  },
};

const RecurrenceDialog = (props) => {
  const {
    classes,
    formValues,
    handleChange,
    setOpen,
    repeatPatterns,
    onCancel,
  } = props;

  const changeParam = (key, index, value) => {
    handleChange(
      "recurrence",
      null,
      update(get(formValues, ["recurrence"]), {
        [key]: { $set: value },
      })
    );
  };

  const isValid = () => {
    let valid = true;
    if (get(formValues, ["recurrence", "repeat"]) === "weekly") {
      if (isEmpty(get(formValues, ["recurrence", "on"]))) valid = false;
      if (
        get(formValues, ["recurrence", "ends"]) === "after" &&
        !get(formValues, ["recurrence", "endsAfter"])
      )
        valid = false;
    } else if (get(formValues, ["recurrence", "repeat"]) === "monthly") {
      if (!get(formValues, ["recurrence", "on"])) valid = false;
    }
    if (
      get(formValues, ["recurrence", "ends"]) === "on" &&
      moment(get(formValues, ["recurrence", "endsOn"]))
        .hours(0)
        .minutes(0)
        .valueOf() <
      moment(get(formValues, ["startDate"]))
        .hours(0)
        .minutes(0)
        .valueOf()
    ) {
      valid = false;
    }
    return valid;
  };

  return (
    <Dialog open={true} classes={{ paper: classes.dialogPaper }}>
      <Grid container direction="column">
        <Grid item style={{ marginBottom: "16px" }}>
          <Grid container alignItems="center">
            <Grid item xs={2} />
            <Grid item xs className="dialogTitle">
              {I18n.get("scheduler_recurrenceCustom")}
            </Grid>
            <Grid item xs={2} className={classes.closeIconItem}>
              <CloseIcon closeFunction={() => setOpen(false)} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ padding: "12px" }}>
          <Grid container direction="column">
            <Grid item className={classes.row}>
              <Grid container>
                <Grid item className={classes.label}>
                  {I18n.get("scheduler_repeats")}
                </Grid>
                <Grid item style={{ width: "130px" }}>
                  <CustomSelect
                    name="repeat"
                    value={get(formValues, ["recurrence", "repeat"])}
                    onChange={(e) =>
                      changeParam("repeat", null, e.target.value)
                    }
                    options={map(
                      filter(repeatPatterns, (p) => p.code !== "noRepeat"),
                      (pattern) => ({
                        id: pattern.code,
                        name: I18n.get(`${get(pattern, ["name"])}2`),
                      })
                    )}
                    noSort
                  />
                </Grid>
              </Grid>
            </Grid>
            {get(formValues, ["recurrence", "repeat"]) === "weekly" ? (
              <RecurrenceWeekly
                classes={classes}
                formValues={formValues}
                changeParam={changeParam}
              />
            ) : get(formValues, ["recurrence", "repeat"]) === "daily" ? (
              <RecurrenceDaily
                classes={classes}
                formValues={formValues}
                changeParam={changeParam}
              />
            ) : get(formValues, ["recurrence", "repeat"]) === "monthly" ? (
              <RecurrenceMonthly
                classes={classes}
                formValues={formValues}
                changeParam={changeParam}
              />
            ) : null}
            <Grid item style={{ marginTop: "40px" }}>
              <Grid container justify="center" alignItems="center">
                <Grid item>
                  <CustomButton
                    color="primary"
                    onClick={() => {
                      setOpen(false);
                      onCancel();
                    }}
                  >
                    {I18n.get("site_cancel")}
                  </CustomButton>
                </Grid>
                <Grid item style={{ marginLeft: "10px" }}>
                  <CustomButton
                    variant="contained"
                    color="primary"
                    disabled={!isValid()}
                    onClick={() => setOpen(false)}
                  >
                    {I18n.get("site_confirm")}
                  </CustomButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default withStyles(styles)(RecurrenceDialog);
